module.exports = __webpack_public_path__ + "img/升级按钮新_03.8ffd2e66.png";